import { SourcingEventV2Dto } from "../../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../../common/auth/useLoggedInWithOrgContextState";
import { mayCreateContractFromEvent } from "../../../../common/departments/eventCreationDepartments";

export const useMayCreateContract = (event: SourcingEventV2Dto): boolean => {
  const { selectedOrg } = useLoggedInWithOrgContextState();
  return mayCreateContractFromEvent(selectedOrg, event.homeDepartment?.id);
};
